<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        :class="btnClass"
        fab
        small
        :color="color"
        @click="$emit('click', $event)"
        :data-cy="`grid-button-${icon}`">
        <v-icon v-if="icon" data-cy="grid-button-icon" :small="($attrs.small === true || $attrs.small === '') || $vuetify.breakpoint[$theme.options.compact.gridButton]">{{ icon }}</v-icon>
        <slot></slot>
      </v-btn>
    </template>
    <span data-cy="grid-button-text">{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    color: { type: String, default: 'default lighten-5' },
    icon: { type: String },
    text: { type: String, default: '' }
  },
  computed: {
    btnClass: function () {
      return 'mr-2 ' + (this.$attrs['btn-class'] ? this.$attrs['btn-class'] : ((this.$attrs.small === true || this.$attrs.small === '') || this.$vuetify.breakpoint[this.$theme.options.compact.gridButton] ? 'pa-2' : 'pa-6'))
    }
  }
}
</script>
